import { PhysicsObject, type PhysicsObjectOptions } from "./physicsObject";
import { type Coord } from "./types";

export type GrenadeObjectOptions = PhysicsObjectOptions & { detonationDelayInMs?: number }

export class GrenadeObject extends PhysicsObject {
  detonationTimeout;

  static readonly IMAGE_SRC: string = "";

  constructor(element: HTMLElement, options: GrenadeObjectOptions = {}) {
    super(element, options);

    this.detonationTimeout = setTimeout(
      () => this.detonate(),
      options.detonationDelayInMs ?? 3000,
    );
  }

  detonate() {
    const offset = { x: this.element.offsetWidth / 2, y: this.element.offsetHeight / 2 }
    const coord = this.stop();

    this.detonateAt({ x: coord.x + offset.x, y: coord.y + offset.y });
  }


  detonateAt(_coord: Coord) {
    throw new Error("Cannot detonate a generic GrenadeObject");
  }
}
